const HELLO_PROMPT_PENDING_KEY = 'treechat_new_signup_hello_prompt'
const WALLET_SETUP_PENDING_KEY = 'treechat_new_signup_wallet_setup'
// Dispatched to ask for the hello prompt after the page has already loaded.
export const HELLO_PROMPT_EVENT = 'treechat:hello-prompt'
const UNKNOWN_USER_ID = '*'

function resolveStorage(storage) {
    if (storage) return storage
    if (typeof window === 'undefined') return null

    try {
        return window.sessionStorage
    } catch (_) {
        return null
    }
}

export function markHelloPromptPending(userId, storage) {
    try {
        resolveStorage(storage)?.setItem(
            HELLO_PROMPT_PENDING_KEY,
            userId ? String(userId) : UNKNOWN_USER_ID,
        )
    } catch (_) {}
}

export function consumeHelloPromptPending(userId, storage) {
    const resolvedStorage = resolveStorage(storage)
    if (!resolvedStorage) return false

    try {
        const pendingUserId = resolvedStorage.getItem(HELLO_PROMPT_PENDING_KEY)
        if (!pendingUserId) return false

        resolvedStorage.removeItem(HELLO_PROMPT_PENDING_KEY)
        return pendingUserId === UNKNOWN_USER_ID || pendingUserId === String(userId)
    } catch (_) {
        return false
    }
}

// A browser-wallet signup goes straight into the wallet setup: the setup opens on
// its first render instead of after its network calls, so the feed never shows.
export function markWalletSetupPending(userId, storage) {
    try {
        resolveStorage(storage)?.setItem(
            WALLET_SETUP_PENDING_KEY,
            userId ? String(userId) : UNKNOWN_USER_ID,
        )
    } catch (_) {}
}

export function consumeWalletSetupPending(userId, storage) {
    const resolvedStorage = resolveStorage(storage)
    if (!resolvedStorage) return false

    try {
        const pendingUserId = resolvedStorage.getItem(WALLET_SETUP_PENDING_KEY)
        if (!pendingUserId) return false

        resolvedStorage.removeItem(WALLET_SETUP_PENDING_KEY)
        return pendingUserId === UNKNOWN_USER_ID || pendingUserId === String(userId)
    } catch (_) {
        return false
    }
}
